import ReactMarkdown from 'react-markdown';

/**
 * Renders Markdown safely (no raw HTML). Use for assistant replies so **bold** and lists work.
 */
export default function MarkdownBlock({ children, className = '' }) {
  if (children == null || children === '') return null;
  const text = typeof children === 'string' ? children : String(children);

  return (
    <div className={`markdown-block ${className}`}>
      <ReactMarkdown
        components={{
          p: ({ children: c }) => <p className="mb-2 last:mb-0">{c}</p>,
          strong: ({ children: c }) => <strong className="font-semibold text-[#1e1e2e]">{c}</strong>,
          em: ({ children: c }) => <em className="italic">{c}</em>,
          ul: ({ children: c }) => <ul className="my-2 ml-4 list-disc space-y-1">{c}</ul>,
          ol: ({ children: c }) => <ol className="my-2 ml-4 list-decimal space-y-1">{c}</ol>,
          li: ({ children: c }) => <li className="leading-relaxed">{c}</li>,
          h1: ({ children: c }) => <h3 className="mt-3 mb-2 text-base font-semibold text-[#1e1e2e]">{c}</h3>,
          h2: ({ children: c }) => <h4 className="mt-2 mb-1 text-sm font-semibold text-[#1e1e2e]">{c}</h4>,
          h3: ({ children: c }) => <h4 className="mt-2 mb-1 text-sm font-semibold text-[#1e1e2e]">{c}</h4>,
          code: ({ children: c, className: codeClass }) =>
            codeClass ? (
              <code className={codeClass}>{c}</code>
            ) : (
              <code className="rounded bg-[#f5f6fb] px-1 py-0.5 font-mono text-[12px] text-[#1e1e2e]">{c}</code>
            ),
          pre: ({ children: c }) => (
            <pre className="my-2 overflow-x-auto rounded-lg bg-[#1e1e2e] p-3 font-mono text-xs text-[#e2e8f0]">{c}</pre>
          ),
          a: ({ href, children: c }) => (
            <a
              href={href}
              className="text-[#5b63ea] underline underline-offset-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              {c}
            </a>
          ),
          blockquote: ({ children: c }) => (
            <blockquote className="my-2 border-l-2 border-[#5b63ea]/40 pl-3 text-[#6b7280]">{c}</blockquote>
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
